<div class="map-marker-toolbar">
    <ng-container *ngIf="popupView === 'default'">
        <div
            class="input-group map-marker-categories"
            btnRadioGroup
            [(ngModel)]="feature.categoryId"
            (ngModelChange)="onCategoryChange()"
        >
            <label
                class="btn btn-xs btn-pill"
                [btnRadio]="category.id"
                *ngFor="let category of featureGroup.categories"
                >{{ category.name }}</label
            >
        </div>
        <!--
            to prevent a delete or backspace press to propagate to MapService which will delete the feature,
            $event.stopPropagation() is used
        -->
        <input
            *ngIf="feature"
            class="form-control input-sm fill top-buffer"
            placeholder="Feature Name"
            (keyup)="$event.stopPropagation()"
            [(ngModel)]="feature.name"
            (ngModelChange)="onFeatureNameChange()"
        />

        <div
            *ngIf="feature?.properties?.lineOffsetMeters"
            class="line-offset-container"
        >
            <label for="lineoffset-meters">Line offset (meters)</label>
            <input
                id="lineoffset-meters"
                class="form-control input-sm fill top-buffer"
                type="number"
                min="1"
                (keyup)="$event.stopPropagation()"
                [(ngModel)]="feature.properties.lineOffsetMeters"
                (ngModelChange)="onFeatureOffsetChange()"
            />
        </div>

        <div *ngIf="isCircleFeature" class="radius-container">
            <label for="radius-metres">Radius (meters)</label>
            <input
                id="radius-metres"
                class="form-control input-sm fill top-buffer"
                type="number"
                min="1"
                (keyup)="$event.stopPropagation()"
                [(ngModel)]="feature.properties.radiusMetres"
                (ngModelChange)="onFeatureRadiusChange()"
            />
        </div>

        <div
            *ngIf="
                allowEditCoordinates &&
                feature &&
                feature.geom &&
                feature.geom.type === 'Point'
            "
        >
            <label for="longitude">Longitude</label>
            <input
                class="form-control input-sm fill top-buffer"
                placeholder="Longitude"
                (keyup)="$event.stopPropagation()"
                [(ngModel)]="feature.geom.coordinates[0]"
                (ngModelChange)="onFeatureCoordinatesChange()"
            />

            <label for="lattitude">Latitude</label>
            <input
                class="form-control input-sm fill top-buffer"
                placeholder="Latitude"
                (keyup)="$event.stopPropagation()"
                [(ngModel)]="feature.geom.coordinates[1]"
                (ngModelChange)="onFeatureCoordinatesChange()"
            />
        </div>

        <div class="action-row">
            <div>
                <button
                    type="button"
                    class="btn btn-tertiary"
                    tooltip-placement="right"
                    tooltip="Edit feature"
                    (click)="onFeatureEditClick()"
                >
                    <span class="fal fa-pencil-alt"></span>
                </button>
                <button
                    type="button"
                    class="btn btn-tertiary btn-delete"
                    tooltip="Delete feature"
                    (click)="onFeatureDeleteClick()"
                    placement="right"
                >
                    <span class="fal fa-trash-alt"></span>
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-link btn-inline"
                    *ngIf="
                        canConvertToCorridor &&
                        feature?.geom?.type === 'LineString'
                    "
                    (click)="onConvertClick()"
                >
                    Change to corridor
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    *ngIf="canCancelConversion"
                    (click)="onConvertCancelClick()"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-primary btn-xs"
                    *ngIf="
                        canBufferPolygon && feature?.geom?.type === 'Polygon'
                    "
                    (click)="openBufferView()"
                >
                    Buffer
                </button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="popupView === 'buffer'">
        <label for="buffer-meters">Buffer (meters)</label>
        <input
            id="buffer-meters"
            class="form-control input-sm fill"
            type="number"
            (keyup)="$event.stopPropagation()"
            [(ngModel)]="bufferMeters"
            (ngModelChange)="onBufferChange()"
        />
        <div class="buffer-view-footer">
            <button
                type="button"
                class="btn btn-link"
                (click)="cancelBufferView()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn btn-primary btn-xs"
                (click)="applyBufferView()"
            >
                Apply
            </button>
        </div>
    </ng-container>
</div>
